// Indicatore visivo priorità ticket
import type { TicketPriority } from '@fieldcore/types'
import { cn } from '../../lib/utils'
import { AlertCircle, ArrowDown, ArrowUp, Zap } from 'lucide-react'

const PRIORITY_LABELS: Record<TicketPriority, string> = {
  low: 'Bassa',
  medium: 'Media',
  high: 'Alta',
  critical: 'Critica',
}

const PRIORITY_CLASSES: Record<TicketPriority, string> = {
  low: 'priority-low',
  medium: 'priority-medium',
  high: 'priority-high',
  critical: 'priority-critical',
}

const PRIORITY_ICONS: Record<TicketPriority, React.ReactNode> = {
  low: <ArrowDown className="h-3 w-3" />,
  medium: <ArrowUp className="h-3 w-3" />,
  high: <AlertCircle className="h-3 w-3" />,
  critical: <Zap className="h-3 w-3" />,
}

interface PriorityIndicatorProps {
  priority: TicketPriority
  className?: string
  showLabel?: boolean
}

export function PriorityIndicator({ priority, className, showLabel = true }: PriorityIndicatorProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 text-xs font-medium',
        PRIORITY_CLASSES[priority],
        className
      )}
      aria-label={`Priorità: ${PRIORITY_LABELS[priority]}`}
    >
      {PRIORITY_ICONS[priority]}
      {showLabel && PRIORITY_LABELS[priority]}
    </span>
  )
}
